import { render, staticRenderFns } from "./bzrNow.vue?vue&type=template&id=38d077e6&scoped=true"
import script from "./bzrNow.vue?vue&type=script&lang=js"
export * from "./bzrNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d077e6",
  null
  
)

export default component.exports